import Symbol from 'es6-symbol'

export const range = (start = 0, stop, step = 1) => {
  if (stop === undefined) {
    [start, stop] = [0, start]
  }

  start -= step
  return {
    [Symbol.iterator]: () => ({
      next: () => ({
        value: (start += step),
        done: start === stop
      })
    })
  }
}

export const getPowOf = v => (1e-1 ** v).toFixed(v)

export const getDateRange = (period = '1w') => {
  const date = new Date()
  const end = date.setHours(24, 0, 0, 0)
  let start
  switch (period) {
  case '3m':
    start = date.setMonth(date.getMonth() - 3)
    break
  case '1m':
    start = date.setMonth(date.getMonth() - 1)
    break
  case '1w':
    start = date.setDate(date.getDate() - 7)
    break
  case '1d':
  default:
    start = date.setDate(date.getDate() - 1)
    break
  }
  if (period !== '1d') start = date.setDate(date.getDate() - 1)
  return {start, end}
}

export const objectFlip = obj => {
  const ret = {}
  Object.keys(obj).forEach(key => {
    ret[obj[key]] = key
  })
  return ret
}

export const isEmptyObj = obj => Object.keys(obj).length === 0
